<template>
  <div>
    <div class="grid gap-4 py-6 border-t bg-gray-50 md:grid-cols-3 auto-rows-auto lg:grid-cols-5">
      <DatePicker class="md:col-span-2" color="indigo" mode="dateTime" :minute-increment="5" is-range is24hr v-model="filter.date" :model-config="{ start: { timeAdjust: '00:00:00' }, end: { timeAdjust: '23:59:59' } }">
        <template v-slot="{ inputValue, inputEvents }">
          <div class="flex justify-center">
            <input
              :value="inputValue.start"
              v-on="inputEvents.start"
              class="form-input prepend"
            />
            <div class="flex items-center justify-center flex-none w-10 text-gray-500 border-t border-b border-gray-300">
              &rarr;
            </div>
            <input
              :value="inputValue.end"
              v-on="inputEvents.end"
              class="form-input append"
            />
          </div>
        </template>
      </DatePicker>

      <vehicle-select v-model="filter.vehicleId" />
    </div>

    <div>
      <div v-if="report">
      <!-- No Results -->
        <div v-if="report.rows.length === 0" class="p-8 m-6 text-center text-gray-500 rounded-b-lg bg-gray-50">
          No results. Try broadening your query parameters.
        </div>
        <!-- Results -->
        <div class="card" v-else>
          <div class="flex flex-col justify-between p-4 border-b md:flex-row lg:p-5">
            <button class="ml-auto btn btn-sm btn-outline" @click="download()">
              <fa :icon="['far', 'arrow-to-bottom']" class="mr-2" /> Download
            </button>
          </div>
          <data-table
            small
            :items="report.rows" 
            :keys="[
              { name: 'Order No.', slug: 'id' },
              { name: 'Route', slug: 'route' },
              { name: 'Type', slug: 'type' },
              { name: 'Status', slug: 'status', 
                display: (val) => {
                  return val === 'Cancelled' ? `<span class='text-red-600'>${val}</span>` : `<span class='text-green-600'>${val}</span>` 
                }
              },
              { name: 'Planned Arrival', slug: 'planned_arrival' },
              { name: 'Actual Arrival', slug: 'actual_arrival' },
              { name: 'Variance', slug: 'variance',
                display: (val) => {
                  return `<div class='text-right'>${val}</div>`
                } 
              },
              { name: 'Text', slug: 'text' }
            ]" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sub, formatDuration } from 'date-fns'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import VehicleSelect from '@/components/VehicleSelect'

export default {
  name: 'DebriefReport',

  components: {
    DatePicker,
    VehicleSelect
  },

  props: {
    report: {
      type: Object
    }
  },

  computed: {
    params () {
      return { 
        filter: this.filter
      }
    }
  },

  data () {
    return {
      filter: {
        date: {
          start: sub(new Date(), { days: 30 }),
          end: new Date()
        }
      }
    }
  }
}
</script>